import { InvSterilizationMethodEnum } from "@brewbase/db/types";
/** Sterilization methods in picker order. */
export const STERILIZATION_METHODS = Object.values(InvSterilizationMethodEnum);
export function isSterilizationMethod(value) {
    return STERILIZATION_METHODS.includes(value);
}
const METHOD_NAMES = {
    [InvSterilizationMethodEnum.AUTOCLAVE]: "Autoclave",
    [InvSterilizationMethodEnum.FILTRATION]: "Filtration",
    [InvSterilizationMethodEnum.UV]: "UV",
    [InvSterilizationMethodEnum.CHEMICAL]: "Chemical",
    [InvSterilizationMethodEnum.DRY_HEAT]: "Dry Heat",
    [InvSterilizationMethodEnum.OTHER]: "Other",
};
export function sterilizationMethodName(method) {
    return METHOD_NAMES[method];
}
/**
 * The range an autoclave run is accepted in. The server rejects values
 * outside it; the form clamps to it.
 */
export const AUTOCLAVE_TEMPERATURE_C = { min: 100, max: 150 };
export const AUTOCLAVE_HOLD_MIN = { min: 1, max: 1440 };
/**
 * The one sterilization label used everywhere (form preview, ready shelf,
 * picker, board, item label), e.g. "130 °C · 5 h + HCl 2 mL/kg".
 *
 * An autoclave shows its temperature and hold (whole hours in h, else min);
 * the parts that were never recorded are left out, and with neither it falls
 * back to the method name. Filtration is "Filtered"; other methods show their
 * name. Values are shown as entered.
 */
export function sterilizationLabel(input) {
    const base = methodPart(input);
    const additives = (input.additives ?? [])
        .map((a) => ` + ${a.label} ${a.mlPerKg} mL/kg`)
        .join("");
    return base + additives;
}
function methodPart({ method, temperatureC, holdMin, }) {
    if (method === InvSterilizationMethodEnum.FILTRATION)
        return "Filtered";
    if (method !== InvSterilizationMethodEnum.AUTOCLAVE)
        return sterilizationMethodName(method);
    const parts = [];
    if (temperatureC !== null)
        parts.push(`${temperatureC} °C`);
    if (holdMin !== null)
        parts.push(holdMin % 60 === 0 ? `${holdMin / 60} h` : `${holdMin} min`);
    return parts.length > 0 ? parts.join(" · ") : sterilizationMethodName(method);
}
//# sourceMappingURL=sterilization-label.js.map